import React from 'react';
import { Row, Col, Button } from 'antd';
import { FaPlus } from 'react-icons/fa';

export interface EmptyContainerProps {
  title: string;
  icon: string;
  onClick?: (e?: React.MouseEvent) => void;
}

export const EmptyContainer: React.FC<EmptyContainerProps> = ({
  title,
  icon,
  onClick,
}) => {
  return (
    <Row className="empty-meals-container" justify="center">
      <Col span={24} className="empty-meals-wrapper">
        <img src={icon} alt="meals" />
        <span>{title}</span>
      </Col>
      {onClick && (
        <div className="floating-button">
          <Button shape="circle" size="large" onClick={onClick}>
            <FaPlus size={14} />
          </Button>
        </div>
      )}
    </Row>
  );
};
